// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HBXrq","field":"styles_field__hrAPt","fieldCol":"styles_fieldCol__1LWfJ","diffCol":"styles_diffCol__2Xxtz","diff":"styles_diff__MK8F4"};